import { render, staticRenderFns } from "./RutasPaciente.vue?vue&type=template&id=41f5cc6c&scoped=true"
import script from "./RutasPaciente.vue?vue&type=script&lang=js"
export * from "./RutasPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f5cc6c",
  null
  
)

export default component.exports